{
  "en": {
    "document": {
      "actions": {
        "delete": "Delete",
        "deleteMultipleDocuments": "Delete",
        "delete_cancel": "Cancel",
        "delete_documents": "Delete document | Delete documents",
        "delete_documents_upload": "Remove {count} document | Remove {count} documents",
        "download": "Download",
        "edit": "Edit",
        "groupByCategory": "Toggle grouping by category",
        "hideDetails": "Hide details",
        "new": "Documents",
        "new_customer": "Add documents",
        "reset_filters": "Reset filters",
        "share": "Share",
        "shareCustomer": "Share with customer",
        "shareCustomerPartners": "Share with customer and project partners",
        "shareWithProjectPartners": "Share/unshare with Project Partners...",
        "share_documents": "Share document | Share documents",
        "share_with": "Share with...",
        "showDetails": "Show details",
        "submit": "Submit",
        "tickBoxesDeletion": "Tick the checkboxes of the files you would like to have deleted.",
        "unshare": "Unshare",
        "unshare_documents": "Unshare document | Unshare documents"
      },
      "attachable_types": {
        "building": "Building",
        "decisions": "Decisions",
        "installment": "Installment",
        "issue": "Snag",
        "lot": "Plot",
        "phase": "Phase",
        "project": "Project",
        "tickets": "Conversations",
        "unit": "Unit"
      },
      "attributes": {
        "category": "Category",
        "file_ext": "File Type",
        "file_size": "File size",
        "name": "Name",
        "size": "Size",
        "type": "Type",
        "uploaded_at": "Uploaded at",
        "uploaded_by": "Uploaded by"
      },
      "category": {
        "admin": "Administration",
        "aftercare": "Aftercare",
        "as_built": "As-built File",
        "brochure": "Brochure",
        "conversation": "Conversation",
        "decision": "Decision",
        "image": "Image",
        "invoice": "Invoice",
        "legal": "Legal",
        "manual": "Manual",
        "other": "Other",
        "plan": "Plan",
        "quote": "Quote",
        "ticket": "Conversation"
      },
      "labels": {
        "actions": "Actions",
        "allDocuments": "All documents",
        "allUnits": "All Units",
        "backToCategories": "Categories",
        "building": "building",
        "categories": "Categories",
        "category": "Category",
        "changeCategory": "Change category to:",
        "changeFilterOrStartUploading": "Change filter or upload a new document",
        "created": "Created",
        "customer": "Customer",
        "decision": "decision",
        "decisionsAndProposals": "Decisions and Proposals",
        "delete_documents": "Are you sure you want to remove this document? This action cannot be undone. | Are you sure you want to remove these documents? This action cannot be undone.",
        "disclaimerDocumentsCustomer": "Find or upload documents related to decision {decision_name}",
        "documents": "Documents",
        "documents_all": "All Documents",
        "documents_all_projects": "Documents all projects",
        "documents_plan": "Plan documents",
        "documents_plan_explainer": "Documents added to the {unit_name} documents folder with the category 'Plan' are automatically added to this decision and accessible for all partners. ",
        "editDocument": "Edit Document",
        "editDocumentName": "Edit document name",
        "editDocumentNameSubtitle": "Enter a new name for the document.",
        "fileTooLargeForPreview": "File too large to preview. Try downloading it instead.",
        "files": "Files {level_name}",
        "files_count": "No files | 1 file | {count} files",
        "filter": "Filter",
        "folders": "Folders",
        "goToUnitDocumentsFolder": "Go to {unit_name} documents folder",
        "goToUnitsFolder": "This page contains only decision documents. Go to the unit folder to see the other documents.",
        "include_original_documents": "Show the documents to be signed",
        "includesProposalAndDocuments": "Includes proposal documents and decision documents",
        "info": "Documents related to your home will be available here soon.",
        "locked": "This document belongs to the category 'Plan', and can only be deleted from the Unit documents folder",
        "lockedDocumentApprovedProposal": "This document belongs to an approved proposal and cannot be deleted",
        "lockedDocumentDelete": "This document cannot be deleted",
        "lot": "plot",
        "more_info": "More info",
        "name_asc": "Nome A->Z",
        "name_desc": "Nome Z->A",
        "name_lower_asc": "Nome A->Z",
        "name_lower_desc": "Nome Z->A",
        "new": "New",
        "next": "Next",
        "noCustomer": "No customer assigned yet",
        "noPreviewPossible": "No preview possible for this document type. Try downloading it first.",
        "noResults": "No results",
        "no_plan_documents": "No plan documents added to unit folder",
        "onlyUnitDocumentsSharedWithProjectPartners": "Only Unit documents can be shared with project partners",
        "original_documents": "Original documents",
        "original_documents_info": "Show the original unsigned versions of the documents that are signed or need to be signed.",
        "owner": "Owner",
        "page": "Page",
        "phase": "phase",
        "previous": "Previous",
        "project": "project",
        "project_partners": "Project partners",
        "proposal": "proposal",
        "searchName": "Search by name",
        "search_document": "Search document",
        "selected": "{count} document selected | {count} documents selected",
        "shareWith": "Share with",
        "sharedWithClient": "Shared with {client_name}",
        "sharedWithProjectPartners": "Shared with project partners",
        "shared_with": "Shared with",
        "shared_with_partners": "Shared with partners",
        "sharingSettingsDecision": "Inside this decision",
        "sharingSettingsProject": "In this project",
        "showDocumentsFor": "Show documents for",
        "showLevel": "This is a {level} document",
        "signature": "Signature",
        "signed": "Signed",
        "signedBy": "Signed by",
        "source": "Source",
        "subtitleSharingDocuments": "The selected document will be available for Project Partners | The selected documents will be available for Project Partners",
        "subtitleUnsharingDocuments": "The selected document won't be available for Project Partners | The selected documents won't be available for Project Partners",
        "ticket": "conversation",
        "unit": "unit",
        "unitFolder": "Go to unit documents",
        "updated_at_asc": "Mais antigo primeiro",
        "updated_at_desc": "Mais recente primeiro",
        "upload_failed": "1 or more files failed to upload. Remove them or try to reupload again.",
        "uploadedBy": "Uploaded by",
        "visibleFor": "Shared with",
        "warningNotShared": "Whoops! Nobody has been selected. Are you sure? Click again to confirm."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "You will receive an email notification when a new document is available. View and download them here.",
            "title": "Here you'll find all your documents"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Document uploads will automatically notify all related customers via email.",
            "title": "No documents for {level_name}"
          }
        },
        "partners": {
          "navigate": {
            "subtitle": "Navigate through the project structure to see the documents of a unit",
            "title": "Go to a unit to see documents"
          },
          "new": {
            "subtitle": "Document uploads will automatically notify all related customers via email.",
            "title": "No documents for this decision"
          },
          "none": {
            "subtitle": "Here you'll find documents for {unit}",
            "title": "No documents yet"
          }
        }
      },
      "toasts": {
        "bulk_delete": "Document successfully deleted | Documents successfully deleted",
        "bulk_upload": "Document successfully uploaded | Documents successfully uploaded",
        "update": "{count} document updated successfully | {count} documents updated successfully",
        "upload_success": "{count} document uploaded successfully | {count} documents uploaded successfully"
      },
      "upload": {
        "activeUpload": "Uploading {count} file | Uploading {count} files",
        "clear": "Clear",
        "complete": "Upload complete",
        "navigationWarning": {
          "continue": "Leave anyway",
          "header": "Upload in progress",
          "message": "You have files currently uploading. Leaving this page will cancel the upload and no document will be created."
        },
        "uploadFailed": "Upload failed"
      },
      "validation": {
        "need_category": "Category required",
        "need_category_all": "All documents need to have a category",
        "selectDocument": "Select at least 1 document"
      }
    }
  }
}